module.exports = __webpack_public_path__ + "static/img/simplicicar.99affd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/simplicicar.png
// module id = o/dx
// module chunks = 2